
export default function Footer() {
  const quickLinks = [
    { name: '主播合作', href: '/anchor-cooperation' },
    { name: '工厂合作', href: '/factory-cooperation' },
    { name: '品牌中心', href: '/brand-center' },
    { name: '溯源系统', href: '/traceability' },
    { name: '关于我们', href: '/about' },
    { name: 'Made with Readdy', href: 'https://readdy.ai/?origin=logo' }
  ];

  const contactInfo = [
    { icon: 'ri-phone-line', text: '400-888-9999' },
    { icon: 'ri-mail-line', text: 'cooperation@nandiangucha.com' },
    { icon: 'ri-map-pin-line', text: '云南省昆明市官渡区春城路123号' }
  ];

  return (
    <footer className="bg-gradient-to-r from-blue-900 to-blue-800 text-white">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg">
                <i className="ri-leaf-line text-slate-300 text-xl"></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold" style={{ fontFamily: "Pacifico, serif" }}>南滇古茶</h3>
            </div>
            <p className="text-sm md:text-base text-blue-100 leading-relaxed">
              中国普洱茶供应链首选平台，致力于为主播和工厂搭建高效的合作桥梁，传承千年茶文化。
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-base md:text-lg font-semibold text-slate-300">快速链接</h4>
            <div className="space-y-2">
              {quickLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="block text-sm md:text-base text-blue-100 hover:text-slate-300 transition-colors duration-200 cursor-pointer"
                  target={link.href.startsWith('http') ? '_blank' : '_self'}
                  rel={link.href.startsWith('http') ? 'noopener noreferrer' : ''}
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-base md:text-lg font-semibold text-slate-300">联系我们</h4>
            <div className="space-y-3">
              {contactInfo.map((contact, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${contact.icon} text-slate-300`}></i>
                  </div>
                  <span className="text-sm md:text-base text-blue-100">{contact.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* WeChat QR */}
          <div className="space-y-4">
            <h4 className="text-base md:text-lg font-semibold text-slate-300">微信客服</h4>
            <div className="bg-white p-4 rounded-lg inline-block">
              <img
                src="https://public.readdy.ai/ai/img_res/87424cb18d4f369d9371bef7b925d036.jpg"
                alt="微信客服二维码"
                className="w-24 h-24 object-cover"
              />
            </div>
            <p className="text-xs md:text-sm text-blue-100">扫码添加专属供应链经理</p>
          </div>
        </div>

        <div className="border-t border-blue-700 mt-8 pt-6 text-center">
          <p className="text-sm md:text-base text-blue-100">
            © 2024 南滇古茶供应链. 保留所有权利 | 滇ICP备12345678号
          </p>
        </div>
      </div>
    </footer>
  );
}
